import { moreTransactionIsValid } from "services/sosInventoryService/moreTransaction/isValid";

export function isValid(record, relatedRecords, lines) {
  const errors = moreTransactionIsValid(record, relatedRecords, lines);
  return errors;
}
